import { render, staticRenderFns } from "./productupdatejd.vue?vue&type=template&id=0a2372ee&scoped=true&"
import script from "./productupdatejd.vue?vue&type=script&lang=js&"
export * from "./productupdatejd.vue?vue&type=script&lang=js&"
import style0 from "./productupdatejd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./productupdatejd.vue?vue&type=style&index=1&id=0a2372ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2372ee",
  null
  
)

export default component.exports